<template>
  <div
    class="v-radio-input-group__wrapper"
    :class="{ [extraClass]: !!extraClass }"
  >
    <VRadioInput
      v-for="(item, idx) in items"
      :key="item.label"
      :name="name"
      :label="item.label"
      :value="item.value"
      :hintText="item.hintText"
      :checked="checkedItem === item.value"
      :extraClass="`v-radio-input-element level-${idx} ${item.extraClass} `"
      @input="onChange"
    ></VRadioInput>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VRadioInput from "@/components/VRadioInput";

export default Vue.component("VRadioInputGroup", {
  props: {
    items: VueTypes.arrayOf(
      VueTypes.shape({
        value: VueTypes.any,
        label: VueTypes.string
      })
    ).isRequired,
    checked: VueTypes.any.isRequired,
    name: VueTypes.string.isRequired,
    extraClass: VueTypes.string
  },

  components: {
    VRadioInput
  },

  data() {
    return {
      checkedItem: this.checked || (this.items && this.items[0].value)
    };
  },

  methods: {
    onChange(item) {
      if (this.checkedItem !== item.value) {
        this.checkedItem = item.value;
        this.$emit("change", item.value);
      }
    }
  },

  watch: {
    checked: function(val) {
      if (val !== this.checkedItem) {
        this.checkedItem = val;
      }
    }
  }
});
</script>

<style lang="scss">
$ns: "v-radio-input-group";

.#{$ns}__wrapper {
  .v-radio-input__wrapper {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

// TODO: optimize this
// using for proper displaying hints and get rid of overflow

.v-radio-input__wrapper.v-radio-input-element {
  &.level-0 {
    z-index: 3;
  }

  &.level-1 {
    z-index: 2;
  }

  &.level-2 {
    z-index: 1;
  }

  &.level-3 {
    z-index: 0;
  }
}
</style>
